export const POWER_SUPPLY_SYSTEMS_PATH =
  '/uslugi/gotovye-resheniya-pod-klyuch/sistemy-elektrosnabzheniya-pod-klyuch/';

export const POWER_SUPPLY_PRELIMINARY_DESIGN_ID = '1453';
export const POWER_SUPPLY_WORKING_DOCUMENTATION_ID = '1458';

export const POWER_SUPPLY_SYSTEMS_CONSULTATION_TYPE = 'ELECTRICITY';

export const POWER_SUPPLY_SERVICE_TYPE_ID_LIST = [
  POWER_SUPPLY_PRELIMINARY_DESIGN_ID,
  POWER_SUPPLY_WORKING_DOCUMENTATION_ID,
];

export const POWER_SUPPLY_ELEMENT_BLOCK = 'landingSistemyElektrosnabzheniya';

export const SERVICE_ID_POWER_SUPPLY = '2109';
